
import AppConfigs from 'configs/env'
import { APIUtils } from 'utils'

export const getSasToken = async (payload) => {
  const res = await APIUtils.get(`${AppConfigs.baseURL}/psldp/token`)
  return res
}
